module.exports = __webpack_public_path__ + "static/media/logo_main_top_admin.fab79571.png";